<template>
  <mc-notification appearance="info" verticalalign="middle" closable data-test="maintenance-notification">
    <mc-text-and-icon icon="exclamation-octagon">
      <span>{{ $t("common.maintenanceMessage") }}</span>
    </mc-text-and-icon>
  </mc-notification>
</template>

<script setup lang="ts">
import "@maersk-global/mds-components-core/mc-notification";
import "@maersk-global/mds-components-core/mc-text-and-icon";
import { useGlobals } from "@/utils/globals";

const { $t } = useGlobals();
</script>

<style scoped>
@import "@/scss/layout/_maintenanceBanner.scss";
</style>
